import { FC } from 'react';
import { useMyTranslations } from 'hooks/useMyTranslations';
import ParsersTable from 'components/Tables/ParsersTable';
import { parsersTranslations } from './translations';
import { ParsersTransFields } from './types';
import styles from './parsers.module.scss';

const Parsers: FC = () => {
  const { t } = useMyTranslations<ParsersTransFields>([parsersTranslations.name]);

  return (
    <main className={styles.page}>
      <header className={styles.header}>
        <h2 className={styles.headerTitle}>{t('title')}</h2>
      </header>
      <div className={styles.container}>{<ParsersTable />}</div>
    </main>
  );
};

export default Parsers;
